<template>
  <div class="d-flex align-center" style="height: 50px">
    <div class="d-flex align-center">
      <div class="d-flex justify-space-between" style="width: 220px">
        <div style="width: 120px">{{ kind === 'cen' ? 'Học phí:' : 'Thu hộ / chi hộ:' }}</div>
        <div class="text-right">
          {{ get(item[kind], 'amountDebt', 0) | price }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
export default {
  components: {},
  data() {
    return { get }
  },
  props: {
    kind: String,
    item: Object
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.text-right {
  text-align: right;
  min-width: 70px;
}
</style>
